import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type BadgeVariant =
  | 'new' | 'sale' | 'sold-out' | 'pre-sale' | 'info' | 'highlight' | 'vip'
  | 'success' | 'warning' | 'alert' | 'danger';

@Component({
  selector: 'app-badge',
  template: `
    <span
      class="badge"
      [class.badge--new]="variant() === 'new'"
      [class.badge--sale]="variant() === 'sale'"
      [class.badge--sold-out]="variant() === 'sold-out'"
      [class.badge--pre-sale]="variant() === 'pre-sale'"
      [class.badge--info]="variant() === 'info'"
      [class.badge--highlight]="variant() === 'highlight'"
      [class.badge--vip]="variant() === 'vip'"
      [class.badge--success]="variant() === 'success'"
      [class.badge--warning]="variant() === 'warning'"
      [class.badge--alert]="variant() === 'alert'"
      [class.badge--danger]="variant() === 'danger'"
      [class.badge--overlay]="overlay()"
    >
      <ng-content />
    </span>
  `,
  styleUrl: './badge.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class BadgeComponent {
  variant = input.required<BadgeVariant>();
  // Cuando el badge va encima de una imagen (card, zoom, megamenú reciente),
  // activa una versión con fondo opaco + sombra sutil para que se lea siempre.
  overlay = input(false);
}
